// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"LabelWithInfoButton_infoWrapper__Wfu_9","info":"LabelWithInfoButton_info__fkMy1"};